
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import { P as PendoAnalytics } from './labels-mixin.js';
import 'focus-visible/dist/focus-visible.js';
import { _ as _objectSpread } from './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import './pendo-icon.js';
import 'vue';
import 'lodash/get';
import { P as PendoLoading } from './pendo-loading-mixin.js';
import './pendo-loading-indicator.js';
import PendoButton from './pendo-button.js';
import { C as CollapseTransition } from './collapse-transition-mixin.js';
import 'color';
import 'color-string';
import './color-picker-helper-mixin.js';
import PendoTag from './pendo-tag.js';
import 'v-tooltip';
import './tooltip-mixin.js';
import PendoTooltip from './pendo-tooltip.js';
import PendoDivider from './pendo-divider.js';

function getLineHeight(el) {
  const _window$getComputedSt = window.getComputedStyle(el),
        lineHeight = _window$getComputedSt.lineHeight,
        fontSize = _window$getComputedSt.fontSize;

  if (lineHeight === 'normal') {
    return parseInt(fontSize, 10) * 1.2;
  }

  return parseFloat(lineHeight);
}

function getLastTextNode(el) {
  let node;
  const walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);

  while (node = walk.nextNode()) {
    if (node && node.childNodes && !node.childNodes.length) {
      node = node;
      break;
    }
  }

  return node;
}

function truncateTextNode(textNode, el, maxHeight) {
  let textContent = textNode.textContent;
  textNode.textContent = '';

  if (el.clientHeight > maxHeight) {
    return false;
  }

  const words = textContent.split(' ');

  while (words.pop()) {
    textNode.textContent = words.join(' ');

    if (el.clientHeight <= maxHeight) {
      textNode.textContent = textContent;
      break;
    }

    textContent = textNode.textContent;
  }

  let _textContent = textContent,
      length = _textContent.length;

  while (length > 1) {
    textContent = textContent.substring(0, --length);
    textNode.textContent = `${textContent}\u2026`;

    if (el.clientHeight <= maxHeight) {
      return true;
    }
  }

  return false;
}

function truncate(el, lineCount) {
  const lineHeight = getLineHeight(el);
  const maxHeight = Math.round(lineHeight * lineCount);

  if (el.clientHeight <= maxHeight) {
    return false;
  }

  const lastTextNode = getLastTextNode(el);
  return truncateTextNode(lastTextNode, el, maxHeight);
}

function lineClamp({
  element,
  lineCount = 1
} = {}) {
  return new Promise(resolve => {
    if (!element) {
      resolve(false);
    }

    if (typeof element.style.webkitLineClamp === 'undefined') {
      resolve(truncate(element, lineCount));
    }

    element.style.overflow = 'hidden';
    element.style.textOverflow = 'ellipsis';
    element.style.webkitBoxOrient = 'vertical';
    element.style.display = '-webkit-box';
    element.style.webkitLineClamp = lineCount;
    requestAnimationFrame(() => {
      resolve(element.scrollHeight - 2 > element.clientHeight);
    });
  });
}

var script = {
  name: 'MediaCard',
  components: {
    PendoTag
  },
  directives: {
    PendoTooltip,
    PendoLoading
  },
  inheritAttrs: false,
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    tags: {
      type: Array
    },
    disabled: {
      type: Boolean
    },
    loading: {
      type: Boolean
    }
  },

  data() {
    return {
      titleTooltipContent: null,
      subtitleTooltipContent: null
    };
  },

  watch: {
    title() {
      this.checkTitleOverflow();
    },

    async loading() {
      if (!this.loading) {
        await this.$nextTick();
        this.checkTitleOverflow();
        this.checkSubtitleOverflow();
      }
    }

  },

  async mounted() {
    await this.$nextTick();

    if (!this.loading) {
      this.checkTitleOverflow();
      this.checkSubtitleOverflow();
    }
  },

  methods: {
    async checkTitleOverflow() {
      if (this.$slots.title || this.$scopedSlots.title) {
        return;
      }

      const title = this.$refs.title;

      if (title) {
        const isClamped = await lineClamp({
          element: this.$refs.title,
          lineCount: 2
        });
        this.titleTooltipContent = isClamped ? this.title : null;
      }
    },

    async checkSubtitleOverflow() {
      if (this.$slots.subtitle || this.$scopedSlots.subtitle) {
        return;
      }

      const subtitle = this.$refs.subtitle;

      if (subtitle && subtitle.offsetWidth < subtitle.scrollWidth) {
        this.subtitleTooltipContent = this.subtitle;
      }
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('div', {
    directives: [{
      name: "pendo-loading",
      rawName: "v-pendo-loading:skeleton",
      value: {
        loading: _vm.loading,
        skeletonProps: {
          height: 148
        }
      },
      expression: "{ loading, skeletonProps: { height: 148 } }",
      arg: "skeleton"
    }],
    staticClass: "pendo-card__media-header"
  }, [!_vm.loading && !_vm.disabled ? _c('div', {
    staticClass: "pendo-card__media-overlay"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pendo-card__media-content"
  }, [!_vm.loading ? _vm._t("media") : _vm._e()], 2), _vm._v(" "), !_vm.loading && !_vm.disabled ? _c('div', {
    staticClass: "pendo-card__media-overlay-actions"
  }, [_vm._t("overlay")], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pendo-card__media-body"
  }, [_c('div', {
    directives: [{
      name: "pendo-loading",
      rawName: "v-pendo-loading:skeleton",
      value: {
        loading: _vm.loading,
        skeletonProps: {
          height: 23
        }
      },
      expression: "{ loading, skeletonProps: { height: 23 } }",
      arg: "skeleton"
    }, {
      name: "pendo-tooltip",
      rawName: "v-pendo-tooltip",
      value: {
        content: _vm.titleTooltipContent,
        delay: {
          show: 300,
          hide: 0
        }
      },
      expression: "{ content: titleTooltipContent, delay: { show: 300, hide: 0 }}"
    }],
    ref: "title",
    staticClass: "pendo-card__media-title"
  }, [!_vm.loading && (_vm.title || _vm.$slots.title) ? _c('div', [_vm._t("title", [_vm._v("\n                    " + _vm._s(_vm.title) + "\n                ")])], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "pendo-loading",
      rawName: "v-pendo-loading:skeleton",
      value: {
        loading: _vm.loading,
        skeletonProps: {
          height: 18
        }
      },
      expression: "{ loading, skeletonProps: { height: 18 } }",
      arg: "skeleton"
    }, {
      name: "pendo-tooltip",
      rawName: "v-pendo-tooltip",
      value: {
        content: _vm.subtitleTooltipContent,
        delay: {
          show: 300,
          hide: 0
        }
      },
      expression: "{ content: subtitleTooltipContent, delay: { show: 300, hide: 0 }}"
    }],
    ref: "subtitle",
    staticClass: "pendo-card__media-subtitle"
  }, [!_vm.loading && (_vm.subtitle || _vm.$slots.subtitle) ? _c('div', [_vm._t("subtitle", [_vm._v("\n                    " + _vm._s(_vm.subtitle) + "\n                ")])], 2) : _vm._e()]), _vm._v(" "), _vm.tags && _vm.tags.length ? [_c('div', {
    staticClass: "pendo-card__media-tags-wrapper"
  }, _vm._l(_vm.tags, function (tag) {
    return _c('pendo-tag', {
      key: tag.label,
      attrs: {
        "type": tag.type,
        "text": tag.text,
        "size": tag.size
      }
    });
  }), 1)] : _vm._e()], 2)]);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "media-card.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var MediaCard = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

var script$1 = {
  name: 'PendoCard',
  components: {
    MediaCard,
    PendoButton,
    PendoDivider,
    CollapseTransition
  },
  directives: {
    PendoAnalytics,
    PendoTooltip,
    PendoLoading
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    height: {
      type: [String, Number],
      default: null
    },
    width: {
      type: [String, Number],
      default: null
    },
    headerMinHeight: {
      type: String,
      default: '48px'
    },
    bodyMinHeight: {
      type: String,
      default: '240px'
    },
    footerMinHeight: {
      type: String,
      default: '155px'
    },
    tags: {
      type: Array,
      default: () => []
    },
    shadow: {
      type: String,
      default: 'never',
      validator: shadow => ['always', 'hover', 'never'].includes(shadow)
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    overlayProps: {
      type: Object,
      default: () => ({})
    },
    collapsible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isHovering: false,
      collapsed: false,
      collapseTooltipContent: 'Collapse'
    };
  },

  computed: {
    showOverlay() {
      if (!this.isMediaCard && !this.isSimpleOverlayCard) {
        return;
      }

      if (this.disabled) {
        return false;
      }

      const _trigger$show$this$ov = _objectSpread({
        trigger: 'hover',
        show: false
      }, this.overlayProps),
            trigger = _trigger$show$this$ov.trigger,
            show = _trigger$show$this$ov.show;

      if (trigger === 'hover' && this.isHovering) {
        return true;
      }

      if (trigger === 'hover' && !this.isHovering) {
        return !!show;
      }

      return trigger === 'manual' && !!show;
    },

    showHeader() {
      return !!this.$slots.header || !!this.$slots.headerRight || !!this.$slots.headerActions || !!this.$slots.title || !!this.title || this.collapsible;
    },

    isMediaCard() {
      return !!this.$slots.media || !!this.$slots.image;
    },

    isSimpleOverlayCard() {
      return !!this.$slots.content && !!this.$slots.overlay;
    },

    shadowType() {
      return this.disabled ? 'never' : this.shadow;
    }

  },
  methods: {
    onMouseenter(event) {
      this.isHovering = true;
      this.$emit('mouseenter', event);
    },

    onMouseleave(event) {
      this.isHovering = false;
      this.$emit('mouseleave', event);
    },

    collapseCard() {
      requestAnimationFrame(() => {
        this.collapsed = true;
        this.collapseTooltipContent = 'Expand';
        this.$emit('collapse-change', {
          collapsed: this.collapsed
        });
      });
    },

    expandCard() {
      requestAnimationFrame(() => {
        this.collapsed = false;
        this.collapseTooltipContent = 'Collapse';
        this.$emit('collapse-change', {
          collapsed: this.collapsed
        });
      });
    },

    toggleCardCollapse() {
      this.collapseTooltipContent = null;

      if (this.collapsed) {
        return this.expandCard();
      }

      this.collapseCard();
    }

  }
};

const __vue_script__$1 = script$1;

var __vue_render__$1 = function () {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    directives: [{
      name: "pendo-analytics",
      rawName: "v-pendo-analytics",
      value: {
        type: 'components:card',
        value: _vm.title
      },
      expression: "{ type: 'components:card', value: title }"
    }],
    staticClass: "pendo-card",
    class: (_obj = {
      'pendo-card--collapsible': _vm.collapsible,
      'pendo-card--tags': _vm.tags.length,
      'pendo-card--media': _vm.isMediaCard,
      'pendo-card--simple': _vm.isSimpleOverlayCard,
      'is-collapsed': _vm.collapsed,
      'is-loading': _vm.loading,
      'is-disabled': _vm.disabled,
      'is-showing-overlay': _vm.showOverlay
    }, _obj["is-" + _vm.shadowType + "-shadow"] = _vm.shadowType, _obj),
    style: {
      height: _vm.height,
      width: _vm.width
    },
    on: {
      "mouseenter": _vm.onMouseenter,
      "mouseleave": _vm.onMouseleave
    }
  }, [_vm.isMediaCard ? _c('media-card', _vm._b({}, 'media-card', _vm.$props, false), [_c('template', {
    slot: "media"
  }, [_vm._t(_vm.$slots.media ? 'media' : 'image')], 2), _vm._v(" "), _c('template', {
    slot: "title"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('template', {
    slot: "subtitle"
  }, [_vm._t("subtitle")], 2), _vm._v(" "), _c('template', {
    slot: "overlay"
  }, [_vm._t("overlay")], 2)], 2) : _vm._e(), _vm._v(" "), _vm.isSimpleOverlayCard ? [!_vm.disabled ? _c('div', {
    staticClass: "pendo-card__simple-overlay",
    style: {
      background: "rgba(42, 44, 53, " + (_vm.overlayProps.opacity || 0.8) + ")"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pendo-card__simple-content"
  }, [_vm._t("content")], 2), _vm._v(" "), !_vm.disabled ? _c('div', {
    staticClass: "pendo-card__simple-overlay-actions"
  }, [_vm._t("overlay")], 2) : _vm._e()] : _vm._e(), _vm._v(" "), !_vm.isMediaCard && !_vm.isSimpleOverlayCard ? [_vm.showHeader ? _c('div', {
    staticClass: "pendo-card__header",
    style: {
      minHeight: _vm.headerMinHeight
    }
  }, [_vm._t("header", [_c('div', {
    staticClass: "pendo-card__header--left"
  }, [_vm._t("title", [_vm._v("\n                        " + _vm._s(_vm.title) + "\n                    ")])], 2), _vm._v(" "), _vm.$slots.headerRight || _vm.$slots.headerActions || _vm.collapsible ? _c('div', {
    staticClass: "pendo-card__header--right"
  }, [_vm._t("headerRight"), _vm._v(" "), _c('div', {
    staticClass: "pendo-card__header-actions"
  }, [_vm._t("headerActions"), _vm._v(" "), _vm.collapsible ? [_c('pendo-divider', {
    attrs: {
      "direction": "vertical",
      "width": "1px",
      "height": "24px",
      "stroke": "#DADCE5"
    }
  }), _vm._v(" "), _c('pendo-button', {
    directives: [{
      name: "pendo-tooltip",
      rawName: "v-pendo-tooltip",
      value: {
        content: _vm.collapseTooltipContent,
        delay: {
          show: 500,
          hide: 0
        }
      },
      expression: "{ content: collapseTooltipContent, delay: { show: 500, hide: 0 } }"
    }],
    staticClass: "pendo-card__header-action pendo-card__header-action--collapse",
    attrs: {
      "type": "secondary",
      "icon": "chevron-up",
      "icon-size": "16"
    },
    on: {
      "click": _vm.toggleCardCollapse
    }
  })] : _vm._e()], 2)], 2) : _vm._e()])], 2) : _vm._e(), _vm._v(" "), _c('collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.collapsed,
      expression: "!collapsed"
    }],
    staticClass: "pendo-card__content"
  }, [_vm.$slots.body || _vm.$slots.default || _vm.$slots.filters ? _c('div', {
    staticClass: "pendo-card__body",
    style: {
      minHeight: _vm.bodyMinHeight
    }
  }, [_vm.$slots.filters ? _c('div', {
    staticClass: "pendo-card__filters"
  }, [_vm._t("filters")], 2) : _vm._e(), _vm._v(" "), _vm._t(_vm.$slots.body ? 'body' : 'default')], 2) : _vm._e(), _vm._v(" "), _vm._t("sections"), _vm._v(" "), _vm.$slots.footer ? _c('div', {
    staticClass: "pendo-card__footer",
    style: {
      minHeight: _vm.footerMinHeight
    }
  }, [_vm._t("footer")], 2) : _vm._e()], 2)])] : _vm._e()], 2);
};

var __vue_staticRenderFns__$1 = [];
const __vue_inject_styles__$1 = undefined;
const __vue_scope_id__$1 = undefined;
const __vue_is_functional_template__$1 = false;

function __vue_normalize__$1(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-card.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoCard = __vue_normalize__$1({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1);

export default PendoCard;
